import { Component, ComponentFactoryResolver, Injector, Input, OnInit } from '@angular/core';
import { CustomerDetailModalComponent, CustomerDetailModalContext } from '@max/customer/detail/customer-detail-modal/customer-details-modal.component';
import { CustomerService } from '@max/customer/shared/customer.service';
import { CustomerStatusType } from '../../../Foundation/models/enums/customer-status-type.enum';
import { Subscription } from 'rxjs';
import { getServerDate } from '../../helpers/time-helpers.model';
import { MvdModalService } from '../../services/modal/mvd-modal.service';
import { SearchResultService } from '../search/search-results/search-result.service';
import { BaseCustomerAdvancedResultsComponent } from './base-customer-advanced-results.component';

@Component({
    selector: 'customer-omnisearch-results',
    outputs: ['onItemSelected', 'onItemRemoved'],
    templateUrl: './customer-omnisearch-results.html'
})

export class CustomerOmnisearchResultsComponent extends BaseCustomerAdvancedResultsComponent implements OnInit {
    @Input() results: any[];
    @Input() allowDelete = true;

    public showNoResultsfound = false;
    public formattedDate: any;
    public readOnly = false;
    public showDob = false;
    private itemSelectedSubscription: Subscription;
    public customerStatusTypes: CustomerStatusType = new CustomerStatusType();

    constructor(
        protected componentFactoryResolver: ComponentFactoryResolver,
        protected injector: Injector,
        protected searchResultService: SearchResultService,
        protected customerService: CustomerService,
        protected modalService: MvdModalService
    ) {
        super(componentFactoryResolver, injector, searchResultService, customerService, modalService);
        this.displayResults = false;
    }

    async ngOnInit() {
        this.searchResultService.receiveContext(this.componentFactoryResolver, this.injector);
        this.displayResults = true;

        // this.showNoResultsfound = false;

        if (this.results && this.results.length > 1) {
            this.itemSelectedSubscription = this.onItemSelected.subscribe(response => {
                this.showDateOfBirth(response);

                this.itemSelectedSubscription.unsubscribe();
                this.result = response;
            });
            await this.popupAdvancedSearchModal({ results: this.results });
        } else if (this.results && this.results.length == 1) {
            this.result = this.results[0];
            this.onSelect(this.result);
            this.showDateOfBirth(this.result);
        } else if (this.results && this.results.length == 0) {
            this.showNoResultsfound = true;
        }
    }

    showDateOfBirth(result: any) {
        if (result.dateOfBirth) {
            this.showDob = true;
            this.formattedDate = getServerDate(result.dateOfBirth);
        } else {
            this.showDob = false;
            this.formattedDate = '';
        }
    }

    removeCustomer() {
        this.result = undefined;
        this.onRemove();
    }

    popupCustomerSummaryModal(customerNumberId: number) {
        const data = new CustomerDetailModalContext(customerNumberId, true);
        this.modalService.open(CustomerDetailModalComponent, data);
    }

    public viewCustomer(result) {
        if (result.customerTypeId == 1) {
            window.open('../customer/individual/' + result.customerNumber);
        } else if (result.customerTypeId == 2) {
            window.open('../customer/organization/' + result.customerNumber);
        }
    }
}
